import $ from "jquery";
import moment from "moment";
import {isPresent} from "../general";
import _ from "underscore";

$.validator.addMethod("currencyDollarsCents", function(value) {
    return /^\d+\.\d\d$/.test(value);
}, 'Please enter currency in the form: 0.00');


$.validator.addMethod("wholeNumber", function(value) {
    return /^\d+$/.test(value);
}, 'Please enter a whole number (no decimals).');


$.validator.addMethod("dateRange", (val, el, [{dateStart, dateEnd}={}]=[])=>{
  // debugger;
  const dsRaw = dateStart(...arguments).val();
  const deRaw = dateEnd(...arguments).val();

  if(!isPresent(dsRaw) || !isPresent(deRaw)){
    return true;
  }

  const ds = moment(dsRaw, "MM/DD/YYYY");
  const de = moment(deRaw, "MM/DD/YYYY");

  if(!ds.isValid() || !de.isValid()){
    return true;
  }

  return ds.diff(de) < 0;
}, "Please select a valid date range.")



// START
// This Validation can only be used
// by the QuickFileUploader Component,
// or any other component setting a data-attribute
// for 'file-meta'
$.validator.addMethod("maxFileSizeBytes", (val, el, maxBytes)=>{
    el = $(el);
    const fileSize = el.data('file-meta') && el.data('file-meta').size;
    // if there is no file present (aka, no fileSize),
    // this error shouldn't be visible, that is the 
    // responsibility of the 'required' validation
    if(!isPresent(fileSize)){
      return true;
    }
    return fileSize <= maxBytes;
}, `The size of this file too large.`);

$.validator.addMethod("permittedFileTypes", (val, el, permittedFileTypes)=>{
    el = $(el);
    const fileType = el.data('file-meta') && el.data('file-meta').type;
    // Same validation note as mentioned above
    if(!isPresent(fileType)){
      return true;
    }
    return _(permittedFileTypes).any((type)=>{
      return fileType === type;
    });
}, `The file type is not permitted.`);
// END


export function bindFileInputChangeValidation(){
  $(document).on("change", "input[type=file]", function(){
    const input = $(this);
    if(input.get(0).form && input.valid){
      input.valid();
    }
  });
}

$.validator.addClassRules("jqv-whole-number", {wholeNumber: true});




// WEBPACK FOOTER //
// ./src/utilities/jqueryValidationMethods/index.js